import React, { Fragment, useState } from 'react';
import * as Yup from 'yup';
import moment from 'moment';

import { makeStyles } from '@material-ui/core/styles';
import { Formik } from 'formik';

import {
    Box,
    colors,
    Grid,
    Typography,
    Divider,
    Button,
    Dialog,
    DialogContent,
    DialogTitle
} from '@material-ui/core';

import Trackmap from './Trackmap';

const useStyles = makeStyles((theme) => ({
    root: {
    },
    avatar: {
        marginRight: theme.spacing(2),
        backgroundColor: colors.grey[200]
    }
}));


const MapaRota = ({ item, open, closeEdition, changeCenter, openEdition, resultset }) => {

    const classes = useStyles();

    return (
        <Fragment>

            <Dialog aria-modal="true" open={open} aria-labelledby="form-dialog-title" maxWidth="xl" fullWidth className={classes.root} >
                <DialogTitle id="form-dialog-title">
                    <Typography
                        color="textPrimary"
                        variant="h4">
                        <b>Mapa da Rota</b> - {item.nome}
                        {(item.auxiliar == item.nome) ? "" : `${' e ' + item.auxiliar}`} - {moment(item.data).format('DD/MM/YYYY')}
                    </Typography>
                </DialogTitle>
                <Divider />
                <DialogContent>

                    <Formik
                        initialValues={item}
                        validationSchema={
                            Yup.object().shape({
                            })
                        }
                        onSubmit={(values, formik) => {
                            formik.setSubmitting(false);
                        }}

                    >
                        {({
                            errors,
                            handleBlur,
                            handleChange,
                            setFieldValue,
                            handleSubmit,
                            isSubmitting,
                            touched,
                            values
                        }) => (
                            <form onSubmit={handleSubmit}>


                                <Trackmap
                                    item={item}
                                    changeCenter={changeCenter}
                                    openEdition={openEdition}
                                    resultset={resultset} />

                                <Box my={1}></Box>
                                <Divider />

                                <Box my={1}>
                                    <Grid container
                                        direction="row"
                                        justifyContent="flex-end"
                                        alignItems="baseline"
                                        spacing={1}  >

                                        <Grid item >
                                            <Button
                                                color="secondary"
                                                disabled={isSubmitting}
                                                size="small"
                                                variant="contained"
                                                onClick={() => { closeEdition() }}>
                                                Fechar
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Box>

                            </form>
                        )}
                    </Formik>

                </DialogContent>

            </Dialog>

        </Fragment>
    );
};

export default MapaRota;
